import { FormattedMessage } from 'react-intl';
import Box from '@mui/material/Box';
import { ShiftsIcon } from '@atoms/icons';
import { DataGridProgress, EmptyListPlaceholder, PAGE_SIZE_OPTIONS } from '@molecules/dataDisplay';
import { DataGrid } from '@molecules/dataDisplay';
import { useShiftTemplatesListColumns } from './columns';
import { TemplateListItem } from '@libs/models/shiftTemplates';

type TableListPageProps = {
  loading: boolean;
  rows: TemplateListItem[];
  localizationSubset: string;
  onRowClick?: (row: TemplateListItem) => void;
};
export function ShiftTemplatesTable({ loading, rows, localizationSubset, onRowClick }: TableListPageProps) {
  return (
    <Box sx={{ height: '100%', width: '100%', position: 'relative' }}>
      <DataGridProgress loading={loading} />
      <DataGrid
        rows={rows}
        rowHeight={64}
        rowCount={rows.length}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        columns={useShiftTemplatesListColumns({ localizationSubset })}
        // hideFooter
        pagination
        disableVirtualization={false}
        disableRowSelectionOnClick
        onRowClick={(params) => {
          if (params.row) {
            onRowClick && onRowClick(params.row as TemplateListItem);
          }
        }}
        noRowsOverlay={
          <EmptyListPlaceholder
            icon={<ShiftsIcon active />}
            title={<FormattedMessage id={`${localizationSubset}.table.noRows.title`} />}
            subtitle={<FormattedMessage id={`${localizationSubset}.table.noRows.subtitle`} />}
          />
        }
      />
    </Box>
  );
}
